//带带-测试环境2.12.14
const config_dev = {
  ctxPath: 'https://test-play.daidaidj.com',
  // ctxPath: 'https://test2-play.daidaidj.com',
  // ctxPath: 'https://dev2-play.daidaidj.com',
  mobilePath: 'https://test-m.daidaidj.com',
  // socketPath: 'wss://test-im.daidaidj.com',
  prefix: 'https://test-img-play.daidaidj.com/img/',
  mainWebSite: 'https://daidaidj.com',
  clientCtxPath: '/win-download/update/DaiDaiDj_DB73EA269873.exe',
  NIMKey: '1f9e9b3099afc8417cc9b599ee1da050',
  agoraAppID: 'ae8a93c4667949048f81c16065d25ba3',
  channelId: 1000, //渠道
  source: 1, //终端类型 1:pc 2:Android 3:IOS 4:微信小程序 5：QQ小程序
  vnum: 137,
  version: '2.13.18',
  companyId: '281b1d4876684904b48eb4ad6378401d',
  companyIdSY: '264478c6286e41518fab0426eb65f502', // 盛游
  appKey: 'fb0057935f344719b82c3c6bde3a71d2',
  appKeySY: 'fb0057935f344719b82c3c6bde3a71d2', // 盛游
  loginUrl: "https://oemuc-sass-web-test.stnts.com", // 第三方登录地址
  companyCode: 'PP_001',
  securityPath_1: 'https://test-conf.58youxi.com',
  securityPath_2: 'https://test-conf.daidaiyuewan.com',
};
//带带-测试环境 - 完全独立的配置
const config_dev3 = {
  ctxPath: 'https://test3-play.daidaidj.com',
  mobilePath: 'https://test3-m.daidaidj.com',
  // socketPath: 'wss://test3-im.daidaidj.com',
  prefix: 'https://test3-img-play.daidaidj.com/img/',
  windControlPath: 'https://test3-play.daidaidj.com', // 1V1 IM 消息风控上报地址
  mainWebSite: 'https://daidaidj.com',
  clientCtxPath: '/win-download/update/DaiDaiDj_DB73EA269873.exe',
  NIMKey: '1f9e9b3099afc8417cc9b599ee1da050',
  agoraAppID: 'ae8a93c4667949048f81c16065d25ba3',
  channelId: 1000, //渠道
  source: 1, //终端类型 1:pc 2:Android 3:IOS 4:微信小程序 5：QQ小程序
  vnum: 137,
  version: '2.13.18',
  companyId: '281b1d4876684904b48eb4ad6378401d',
  companyIdSY: '264478c6286e41518fab0426eb65f502', // 盛游
  appKey: 'fb0057935f344719b82c3c6bde3a71d2',
  appKeySY: 'fb0057935f344719b82c3c6bde3a71d2', // 盛游
  loginUrl: "https://oemuc-sass-web-test.stnts.com", // 第三方登录地址
  companyCode: 'PP_001',
  securityPath_1: 'https://test3-play.daidaidj.com',
  securityPath_2: 'https://test-conf.daidaiyuewan.com',
};
//带带-预发布环境
const config_demo = {
  ctxPath: 'https://dev-play.daidaidj.com',
  mobilePath: 'https://dev-m.daidaidj.com',
  // socketPath: 'wss://dev-im.daidaidj.com',
  prefix: 'https://dev-img-play.daidaidj.com/img/',
  mainWebSite: 'https://daidaidj.com',
  clientCtxPath: '/win-download/update/DaiDaiDj_DB73EA269873.exe',
  NIMKey: '1f9e9b3099afc8417cc9b599ee1da050',
  agoraAppID: 'ae8a93c4667949048f81c16065d25ba3',
  channelId: 1000, //渠道
  source: 1, //终端类型 1:pc 2:Android 3:IOS 4:微信小程序
  vnum: 137,
  version: '2.13.18',
  companyId: '6b310eb79c5b4bf5bafed4632a493fb6',
  companyIdSY: 'ec574895048549378dbec6e1a51f7400', // 盛游
  appKey: '3693303fb8934d00ae5998a8ac0bb0a4',
  appKeySY: '3693303fb8934d00ae5998a8ac0bb0a4', // 盛游
  loginUrl: "https://reg-saas.daidaidj.com", // 第三方登录地址
  companyCode: 'PP_001',
  securityPath_1: 'https://dev-conf.58youxi.com',
  securityPath_2: 'https://dev-conf.daidaiyuewan.com',
};
//带带-生产环境
const config_pro = {
  ctxPath: 'https://play.daidaidj.com',
  mobilePath: 'https://m.daidaidj.com',
  // socketPath: 'wss://im.daidaidj.com',
  prefix: 'https://img-play.daidaidj.com/img/',
  mainWebSite: 'https://daidaidj.com',
  clientCtxPath: '/win-download/update/DaiDaiDj_DB73EA269873.exe',
  NIMKey: 'b55d55a4ab9cd26044ad6a4ee2380c53',
  agoraAppID: 'b749185af95f48d191c299a88d6fc8a2',
  channelId: 1000, //渠道
  source: 1, //终端类型 1:pc 2:Android 3:ios 4:微信小程序  5:360小程序
  vnum: 137,
  version: '2.13.18',
  companyId: '9f995bd8a2ca47b1bbf61c139916d481',
  companyIdSY: 'ac4d1a65ff7644148b59b8dadffd9f13', // 盛游
  appKey: '91b8830d02c54950a716006e60160753',
  appKeySY: '91b8830d02c54950a716006e60160753', // 盛游
  loginUrl: "https://reg-saas.daidaidj.com", // 第三方登录地址
  companyCode: 'PP_001',
  securityPath_1: 'https://conf.58youxi.com',
  securityPath_2: 'https://conf.daidaiyuewan.com',
};
//带带繁体中文-测试环境
const config_hk_dev = {
  ctxPath: 'https://test-play.daidaidj.com',
  // ctxPath: 'http://192.168.42.159:9013',
  mobilePath: 'https://hk-test-m.daidaidj.com',
  // socketPath: 'wss://test-im.daidaidj.com',
  prefix: 'https://test-img-play.daidaidj.com/img/',
  mainWebSite: 'https://daidaidj.com',
  clientCtxPath: '/win-download/update/DaiDaiDj_DB73EA269873.exe',
  NIMKey: '1f9e9b3099afc8417cc9b599ee1da050',
  agoraAppID: 'ae8a93c4667949048f81c16065d25ba3',
  channelId: 'DB73EA263044', //渠道
  source: 1, //终端类型 1:pc 2:Android 3:IOS 4:微信小程序
  vnum: 137,
  version: '2.13.18',
  companyId: '281b1d4876684904b48eb4ad6378401d',
  companyIdSY: '264478c6286e41518fab0426eb65f502', // 盛游
  appKey: 'fb0057935f344719b82c3c6bde3a71d2',
  appKeySY: 'fb0057935f344719b82c3c6bde3a71d2', // 盛游
  loginUrl: "https://oemuc-sass-web-test.stnts.com", // 第三方登录地址
  companyCode: 'PP_001',
  securityPath_1: 'https://test-conf.58youxi.com',
  securityPath_2: 'https://test-conf.daidaiyuewan.com',
};
// 带带繁体中文 - test3环境
const config_hk_dev3 = {
  ctxPath: 'https://test3-play.daidaidj.com',
  mobilePath: 'https://hk-test3-m.daidaidj.com',
  // socketPath: 'wss://test3-im.daidaidj.com',
  prefix: 'https://test3-img-play.daidaidj.com/img/',
  windControlPath: 'https://test3-play.daidaidj.com', // 1V1 IM 消息风控上报地址
  mainWebSite: 'https://daidaidj.com',
  clientCtxPath: '/win-download/update/DaiDaiDj_DB73EA269873.exe',
  NIMKey: '1f9e9b3099afc8417cc9b599ee1da050',
  agoraAppID: 'ae8a93c4667949048f81c16065d25ba3',
  channelId: 1000, //渠道
  source: 1, //终端类型 1:pc 2:Android 3:IOS 4:微信小程序 5：QQ小程序
  vnum: 137,
  version: '2.13.18',
  companyId: '281b1d4876684904b48eb4ad6378401d',
  companyIdSY: '264478c6286e41518fab0426eb65f502', // 盛游
  appKey: 'fb0057935f344719b82c3c6bde3a71d2',
  appKeySY: 'fb0057935f344719b82c3c6bde3a71d2', // 盛游
  loginUrl: "https://oemuc-sass-web-test.stnts.com", // 第三方登录地址
  companyCode: 'PP_001',
  securityPath_1: 'https://test3-play.daidaidj.com',
  securityPath_2: 'https://test-conf.daidaiyuewan.com',
};
//带带繁体中文-预发布环境
const config_hk_demo = {
  ctxPath: 'https://dev-play.daidaidj.com',
  mobilePath: 'https://hk-test-m.daidaidj.com',
  // socketPath: 'wss://test-im.daidaidj.com',
  prefix: 'https://dev-img-play.daidaidj.com/img/',
  mainWebSite: 'https://daidaidj.com',
  clientCtxPath: '/win-download/update/DaiDaiDj_DB73EA269873.exe',
  NIMKey: '1f9e9b3099afc8417cc9b599ee1da050',
  agoraAppID: 'ae8a93c4667949048f81c16065d25ba3',
  channelId: 'DB73EA263044', //渠道
  source: 1, //终端类型 1:pc 2:Android 3:IOS 4:微信小程序
  vnum: 137,
  version: '2.13.18',
  companyId: '6b310eb79c5b4bf5bafed4632a493fb6',
  companyIdSY: 'ec574895048549378dbec6e1a51f7400', // 盛游
  appKey: '3693303fb8934d00ae5998a8ac0bb0a4',
  appKeySY: '3693303fb8934d00ae5998a8ac0bb0a4', // 盛游
  loginUrl: "https://reg-saas.daidaidj.com", // 第三方登录地址
  companyCode: 'PP_001',
  securityPath_1: 'https://dev-conf.58youxi.com',
  securityPath_2: 'https://dev-conf.daidaiyuewan.com',
};
//带带繁体中文-生产环境
const config_hk_pro = {
  ctxPath: 'https://play.daidaidj.com',
  mobilePath: 'https://hk-m.daidaidj.com',
  // socketPath: 'wss://im.daidaidj.com',
  prefix: 'https://img-play.daidaidj.com/img/',
  mainWebSite: 'https://hk.daidaidj.com',
  clientCtxPath: '/win-download/update/DaiDaiDj_DB73EA269873.exe',
  NIMKey: 'b55d55a4ab9cd26044ad6a4ee2380c53',
  agoraAppID: 'b749185af95f48d191c299a88d6fc8a2',
  channelId: 'DB73EA263044', //渠道
  source: 1, //终端类型 1:pc 2:Android 3:ios 4:微信小程序  5:360小程序
  vnum: 137,
  version: '2.13.18',
  companyId: '9f995bd8a2ca47b1bbf61c139916d481',
  companyIdSY: 'ac4d1a65ff7644148b59b8dadffd9f13', // 盛游
  appKey: '91b8830d02c54950a716006e60160753',
  appKeySY: '91b8830d02c54950a716006e60160753', // 盛游
  loginUrl: "https://reg-saas.daidaidj.com", // 第三方登录地址
  companyCode: 'PP_001',
  securityPath_1: 'https://conf.58youxi.com',
  securityPath_2: 'https://conf.daidaiyuewan.com',
};

let config = {};


// 带带繁体中文-预发布
if (process.env.CLIENT_ENV == 'demonstration' && process.env.LANG == 'zh_TW') {
  config = config_hk_demo;
  config.lang = 'zh_TW';
  config.env = 'demonstration';
}
// 带带繁体中文-生产
else if (process.env.CLIENT_ENV == 'production' && process.env.LANG == 'zh_TW') {
  config = config_hk_pro;
  config.lang = 'zh_TW';
  config.env = 'production';
}
// 带带繁体中文-测试
else if (process.env.CLIENT_ENV == 'development' && process.env.LANG == 'zh_TW') {
  config = config_hk_dev;
  config.lang = 'zh_TW';
  config.env = 'development';
}
//带带-预发布环境
else if (process.env.CLIENT_ENV === 'demonstration') {
  config = config_demo;
  config.lang = 'zh_CN';
  config.env = 'demonstration';
}
//带带-生产环境
else if (process.env.CLIENT_ENV === 'production') {
  config = config_pro;
  config.lang = 'zh_CN';
  config.env = 'production';
}
//带带繁体-test3环境
else if (process.env.CLIENT_ENV === 'development3' && process.env.LANG == 'zh_TW') {
  config = config_hk_dev3;
  config.lang = 'zh_TW';
  config.env = 'development3';
}
//带带-test3环境测试环境
else if (process.env.CLIENT_ENV === 'development3') {
  config = config_dev3;
  config.lang = 'zh_CN';
  config.env = 'development3';
}
//带带-测试环境
else {
  config = config_dev;
  config.lang = 'zh_CN';
  config.env = 'development';
}
//表情包
const emojiList = {
  emoji: {
    '[大笑]': { file: 'emoji_0.png' },
    '[可爱]': { file: 'emoji_01.png' },
    '[色]': { file: 'emoji_02.png' },
    '[嘘]': { file: 'emoji_03.png' },
    '[亲]': { file: 'emoji_04.png' },
    '[呆]': { file: 'emoji_05.png' },
    '[口水]': { file: 'emoji_06.png' },
    '[汗]': { file: 'emoji_145.png' },
    '[呲牙]': { file: 'emoji_07.png' },
    '[鬼脸]': { file: 'emoji_08.png' },
    '[害羞]': { file: 'emoji_09.png' },
    '[偷笑]': { file: 'emoji_10.png' },
    '[调皮]': { file: 'emoji_11.png' },
    '[可怜]': { file: 'emoji_12.png' },
    '[敲]': { file: 'emoji_13.png' },
    '[惊讶]': { file: 'emoji_14.png' },
    '[流感]': { file: 'emoji_15.png' },
    '[委屈]': { file: 'emoji_16.png' },
    '[流泪]': { file: 'emoji_17.png' },
    '[嚎哭]': { file: 'emoji_18.png' },
    '[惊恐]': { file: 'emoji_19.png' },
    '[怒]': { file: 'emoji_20.png' },
    '[酷]': { file: 'emoji_21.png' },
    '[不说]': { file: 'emoji_22.png' },
    '[鄙视]': { file: 'emoji_23.png' },
    '[阿弥陀佛]': { file: 'emoji_24.png' },
    '[奸笑]': { file: 'emoji_25.png' },
    '[睡着]': { file: 'emoji_26.png' },
    '[口罩]': { file: 'emoji_27.png' },
    '[努力]': { file: 'emoji_28.png' },
    '[抠鼻孔]': { file: 'emoji_29.png' },
    '[疑问]': { file: 'emoji_30.png' },
    '[怒骂]': { file: 'emoji_31.png' },
    '[晕]': { file: 'emoji_32.png' },
    '[呕吐]': { file: 'emoji_33.png' },
    '[拜一拜]': { file: 'emoji_160.png' },
    '[惊喜]': { file: 'emoji_161.png' },
    '[流汗]': { file: 'emoji_162.png' },
    '[卖萌]': { file: 'emoji_163.png' },
    '[默契眨眼]': { file: 'emoji_164.png' },
    '[烧香拜佛]': { file: 'emoji_165.png' },
    '[晚安]': { file: 'emoji_166.png' },
    '[强]': { file: 'emoji_34.png' },
    '[弱]': { file: 'emoji_35.png' },
    '[OK]': { file: 'emoji_36.png' },
    '[拳头]': { file: 'emoji_37.png' },
    '[胜利]': { file: 'emoji_38.png' },
    '[鼓掌]': { file: 'emoji_39.png' },
    '[握手]': { file: 'emoji_200.png' },
    '[发怒]': { file: 'emoji_40.png' },
    '[骷髅]': { file: 'emoji_41.png' },
    '[便便]': { file: 'emoji_42.png' },
    '[火]': { file: 'emoji_43.png' },
    '[溜]': { file: 'emoji_44.png' },
    '[爱心]': { file: 'emoji_45.png' },
    '[心碎]': { file: 'emoji_46.png' },
    '[钟情]': { file: 'emoji_47.png' },
    '[唇]': { file: 'emoji_48.png' },
    '[戒指]': { file: 'emoji_49.png' },
    '[钻石]': { file: 'emoji_50.png' },
    '[太阳]': { file: 'emoji_51.png' },
    '[有时晴]': { file: 'emoji_52.png' },
    '[多云]': { file: 'emoji_53.png' },
    '[雷]': { file: 'emoji_54.png' },
    '[雨]': { file: 'emoji_55.png' },
    '[雪花]': { file: 'emoji_56.png' },
    '[爱人]': { file: 'emoji_57.png' },
    '[帽子]': { file: 'emoji_58.png' },
    '[皇冠]': { file: 'emoji_59.png' },
    '[篮球]': { file: 'emoji_60.png' },
    '[足球]': { file: 'emoji_61.png' },
    '[垒球]': { file: 'emoji_62.png' },
    '[网球]': { file: 'emoji_63.png' },
    '[台球]': { file: 'emoji_64.png' },
    '[咖啡]': { file: 'emoji_65.png' },
    '[啤酒]': { file: 'emoji_66.png' },
    '[干杯]': { file: 'emoji_67.png' },
    '[柠檬汁]': { file: 'emoji_68.png' },
    '[餐具]': { file: 'emoji_69.png' },
    '[汉堡]': { file: 'emoji_70.png' },
    '[鸡腿]': { file: 'emoji_71.png' },
    '[面条]': { file: 'emoji_72.png' },
    '[冰淇淋]': { file: 'emoji_73.png' },
    '[沙冰]': { file: 'emoji_74.png' },
    '[生日蛋糕]': { file: 'emoji_75.png' },
    '[蛋糕]': { file: 'emoji_76.png' },
    '[糖果]': { file: 'emoji_77.png' },
    '[葡萄]': { file: 'emoji_78.png' },
    '[西瓜]': { file: 'emoji_79.png' },
    '[光碟]': { file: 'emoji_80.png' },
    '[手机]': { file: 'emoji_81.png' },
    '[电话]': { file: 'emoji_82.png' },
    '[电视]': { file: 'emoji_83.png' },
    '[声音开启]': { file: 'emoji_84.png' },
    '[声音关闭]': { file: 'emoji_85.png' },
    '[铃铛]': { file: 'emoji_86.png' },
    '[锁头]': { file: 'emoji_87.png' },
    '[放大镜]': { file: 'emoji_88.png' },
    '[灯泡]': { file: 'emoji_89.png' },
    '[锤头]': { file: 'emoji_90.png' },
    '[烟]': { file: 'emoji_91.png' },
    '[炸弹]': { file: 'emoji_92.png' },
    '[枪]': { file: 'emoji_93.png' },
    '[刀]': { file: 'emoji_94.png' },
    '[药]': { file: 'emoji_95.png' },
    '[打针]': { file: 'emoji_96.png' },
    '[钱袋]': { file: 'emoji_97.png' },
    '[钞票]': { file: 'emoji_98.png' },
    '[银行卡]': { file: 'emoji_99.png' },
    '[手柄]': { file: 'emoji_100.png' },
    '[麻将]': { file: 'emoji_101.png' },
    '[调色板]': { file: 'emoji_102.png' },
    '[电影]': { file: 'emoji_103.png' },
    '[麦克风]': { file: 'emoji_104.png' },
    '[耳机]': { file: 'emoji_105.png' },
    '[音乐]': { file: 'emoji_106.png' },
    '[吉他]': { file: 'emoji_107.png' },
    '[火箭]': { file: 'emoji_108.png' },
    '[飞机]': { file: 'emoji_109.png' },
    '[火车]': { file: 'emoji_110.png' },
    '[公交]': { file: 'emoji_111.png' },
    '[轿车]': { file: 'emoji_112.png' },
    '[出租车]': { file: 'emoji_113.png' },
    '[警车]': { file: 'emoji_114.png' },
    '[自行车]': { file: 'emoji_115.png' },
  },
};
//财富值
const wealthDatas = [
  {
    name: '游侠',
    index: 1,
    liveNum: 0,
    v: 1,
    num: 1,
    cfxz: true,
    sjtz: false,
    jcx: false,
    mic: false,
    zgmp: false,
    ltqp: false,
    qzlb: false,
    gzlw: false,
    fjy: false,
    fbt: false,
    jcys: false,
    qzys: false,
    cfys: false,
    mlys: false,
    xmsx: false,
    srkf: false,
    sjlw: false,
  },
  {
    name: '骑士',
    index: 2,
    liveNum: 22500,
    v: 10000,
    num: 1,
    cfxz: true,
    sjtz: false,
    jcx: false,
    mic: false,
    zgmp: false,
    ltqp: false,
    qzlb: false,
    gzlw: false,
    fjy: false,
    fbt: false,
    jcys: false,
    qzys: false,
    cfys: false,
    mlys: false,
    xmsx: false,
    srkf: false,
    sjlw: false,
  },
  {
    name: '勋爵',
    index: 3,
    liveNum: 225000,
    v: 100000,
    num: 4,
    cfxz: true,
    sjtz: true,
    jcx: true,
    mic: true,
    zgmp: false,
    ltqp: false,
    qzlb: true,
    gzlw: false,
    fjy: false,
    fbt: false,
    jcys: false,
    qzys: false,
    cfys: false,
    mlys: false,
    xmsx: false,
    srkf: false,
    sjlw: false,
  },
  {
    name: '男爵',
    index: 4,
    liveNum: 250000,
    v: 1000000,
    num: 6,
    cfxz: true,
    sjtz: true,
    jcx: true,
    mic: true,
    zgmp: false,
    ltqp: false,
    qzlb: true,
    gzlw: true,
    fjy: false,
    fbt: false,
    jcys: false,
    qzys: false,
    cfys: false,
    mlys: false,
    xmsx: false,
    srkf: false,
    sjlw: false,
  },
  {
    name: '子爵',
    index: 5,
    liveNum: 750000,
    v: 2000000,
    num: 6,
    cfxz: true,
    sjtz: true,
    jcx: true,
    mic: true,
    zgmp: false,
    ltqp: false,
    qzlb: true,
    gzlw: true,
    fjy: false,
    fbt: false,
    jcys: false,
    qzys: false,
    cfys: false,
    mlys: false,
    xmsx: false,
    srkf: false,
    sjlw: false,
  },
  {
    name: '伯爵',
    index: 6,
    liveNum: 1250000,
    v: 5000000,
    num: 8,
    cfxz: true,
    sjtz: true,
    jcx: true,
    mic: true,
    zgmp: true,
    ltqp: true,
    qzlb: true,
    gzlw: true,
    fjy: false,
    fbt: false,
    jcys: false,
    qzys: false,
    cfys: false,
    mlys: false,
    xmsx: false,
    srkf: false,
    sjlw: false,
  },
  {
    name: '侯爵',
    index: 7,
    liveNum: 2500000,
    v: 10000000,
    num: 8,
    cfxz: true,
    sjtz: true,
    jcx: true,
    mic: true,
    zgmp: true,
    ltqp: true,
    qzlb: true,
    gzlw: true,
    fjy: false,
    fbt: false,
    jcys: false,
    qzys: false,
    cfys: false,
    mlys: false,
    xmsx: false,
    srkf: false,
    sjlw: false,
  },
  {
    name: '公爵',
    index: 8,
    liveNum: 7500000,
    v: 20000000,
    num: 8,
    cfxz: true,
    sjtz: true,
    jcx: true,
    mic: true,
    zgmp: true,
    ltqp: true,
    qzlb: true,
    gzlw: true,
    fjy: false,
    fbt: false,
    jcys: false,
    qzys: false,
    cfys: false,
    mlys: false,
    xmsx: false,
    srkf: false,
    sjlw: false,
  },
  {
    name: '国王',
    index: 9,
    liveNum: 0,
    v: 50000000,
    num: 14,
    cfxz: true,
    sjtz: true,
    jcx: true,
    mic: true,
    zgmp: true,
    ltqp: true,
    qzlb: true,
    gzlw: true,
    fjy: true,
    fbt: true,
    jcys: true,
    qzys: false,
    cfys: true,
    mlys: true,
    xmsx: false,
    srkf: false,
    sjlw: true,
  },
  {
    name: '帝皇',
    index: 10,
    liveNum: 0,
    v: 100000000,
    num: 16,
    cfxz: true,
    sjtz: true,
    jcx: true,
    mic: true,
    zgmp: true,
    ltqp: true,
    qzlb: true,
    gzlw: true,
    fjy: true,
    fbt: true,
    jcys: true,
    qzys: false,
    cfys: true,
    mlys: true,
    xmsx: true,
    srkf: true,
    sjlw: true,
  },
  {
    name: '幻神',
    index: 11,
    liveNum: 0,
    v: 200000000,
    num: 17,
    cfxz: true,
    sjtz: true,
    jcx: true,
    mic: true,
    zgmp: true,
    ltqp: true,
    qzlb: true,
    gzlw: true,
    fjy: true,
    fbt: true,
    jcys: true,
    qzys: true,
    cfys: true,
    mlys: true,
    xmsx: true,
    srkf: true,
    sjlw: true,
  },
  {
    name: '超神',
    index: 12,
    liveNum: 0,
    v: 500000000,
    num: 17,
    cfxz: true,
    sjtz: true,
    jcx: true,
    mic: true,
    zgmp: true,
    ltqp: true,
    qzlb: true,
    gzlw: true,
    fjy: true,
    fbt: true,
    jcys: true,
    qzys: true,
    cfys: true,
    mlys: true,
    xmsx: true,
    srkf: true,
    sjlw: true,
  },
  {
    name: '天神',
    index: 13,
    liveNum: 0,
    v: 1000000000,
    num: 17,
    cfxz: true,
    sjtz: true,
    jcx: true,
    mic: true,
    zgmp: true,
    ltqp: true,
    qzlb: true,
    gzlw: true,
    fjy: true,
    fbt: true,
    jcys: true,
    qzys: true,
    cfys: true,
    mlys: true,
    xmsx: true,
    srkf: true,
    sjlw: true,
  },
];
// 贵族值
const glamourDatas = [
  {
    name: '海尊',
    index: 1,
    liveNum: 0,
    v: 5000000,
    num: 8,
    gzxz: true,
    sjtz: true,
    jcx: true,
    mic: true,
    zgmp: true,
    ltqp: true,
    qzlb: true,
    fjy: false,
    fbt: false,
    sxgg: true,
    jcys: false,
    qzys: false,
    xmsx: false,
    srkf: false,
    tjgod: false,
    jblw: false,
    slefMic: false,
    jrlwfl: false,
    decz: false,
  },
  {
    name: '海王',
    index: 2,
    v: 10000000,
    num: 12,
    gzxz: true,
    sjtz: true,
    jcx: true,
    mic: true,
    zgmp: true,
    ltqp: true,
    qzlb: true,
    fjy: true,
    fbt: true,
    sxgg: true,
    jcys: true,
    qzys: false,
    xmsx: false,
    srkf: false,
    tjgod: false,
    jblw: false,
    slefMic: false,
    jrlwfl: false,
    decz: true,
  },
  {
    name: '海皇',
    index: 3,
    v: 30000000,
    num: 14,
    gzxz: true,
    sjtz: true,
    jcx: true,
    mic: true,
    zgmp: true,
    ltqp: true,
    qzlb: true,
    fjy: true,
    fbt: true,
    sxgg: true,
    jcys: true,
    qzys: false,
    xmsx: true,
    srkf: true,
    tjgod: false,
    jblw: false,
    slefMic: false,
    jrlwfl: false,
    decz: true,
  },
  {
    name: '海帝',
    index: 4,
    v: 50000000,
    num: 19,
    gzxz: true,
    sjtz: true,
    jcx: true,
    mic: true,
    zgmp: true,
    ltqp: true,
    qzlb: true,
    fjy: true,
    fbt: true,
    sxgg: true,
    jcys: true,
    qzys: true,
    xmsx: true,
    srkf: true,
    tjgod: true,
    jblw: true,
    slefMic: true,
    jrlwfl: true,
    decz: true,
  },
]
//code状态表
const errorCode = {
  200: '操作成功',
  201: '客户端版本不对，需升级sdk',
  301: '被封禁',
  302: '用户名或密码错误',
  315: 'IP限制',
  403: '非法操作或没有权限',
  404: '对象不存在',
  405: '参数长度过长',
  406: '对象只读',
  408: '客户端请求超时',
  413: '验证失败(短信服务)',
  414: '参数错误',
  415: '客户端网络问题',
  416: '频率控制',
  417: '重复操作',
  418: '通道不可用(短信服务)',
  419: '数量超过上限',
  422: '账号被禁用',
  423: '帐号被禁言',
  431: 'HTTP重复请求',
  500: '服务器内部错误',
  503: '服务器繁忙',
  508: '消息撤回时间超限',
  509: '无效协议',
  514: '服务不可用',
  998: '解包错误',
  999: '打包错误',
  801: '群人数达到上限',
  802: '没有权限',
  803: '群不存在',
  804: '用户不在群',
  805: '群类型不匹配',
  806: '创建群数量达到限制',
  807: '群成员状态错误',
  808: '申请成功',
  809: '已经在群内',
  810: '邀请成功',
  811: '@账号数量超过限制',
  812: '群禁言，普通成员不能发送消息',
  813: '群拉人部分成功',
  814: '禁止使用群组已读服务',
  815: '群管理员人数超过上限',
  7101: '对方已屏蔽你的消息',
  9102: '通道失效',
  9103: '已经在他端对这个呼叫响应过了',
  11001: '通话不可达，对方离线状态',
  13001: 'IM主连接状态异常',
  13002: '聊天室状态异常',
  13003: '账号在黑名单中,不允许进入聊天室',
  13004: '你已被禁言',
  13005: '用户的聊天室昵称、头像或成员扩展字段被反垃圾',
  10431: '输入email不是邮箱',
  10432: '输入mobile不是手机号码',
  10433: '注册输入的两次密码不相同',
  10434: '企业不存在',
  10435: '登录密码或帐号不对',
  10436: 'app不存在',
  10437: 'email已注册',
  10438: '手机号已注册',
  10441: 'app名字已经存在',
  13006: '聊天室处于整体禁言状态,只有管理员能发言',
  20000: '不能发送空白消息',
  20001: '消息发送失败，内容涉嫌敏感词啦~',
  20002: '消息发送失败，对方已开启消息免打扰~',
  20003: '[{用户等级}]以下的普通用户不能向普通用户发起私聊哦~',
  20004: '[{用户等级}]以下的普通用户不能向普通用户发送名片哦~',
  20005: '非好友消息条数已达限制，无法继续发送', // 对方未关注你
  20006: '非好友消息条数已达限制，无法继续发送', // 对方已关注你
  20007: '1V1聊天被封停，发送失败~',
  20008: '语音室信息流发言被封停，发送失败~',
  20010: '网络不畅，消息发送失败',
  20019: '消息发送失败',
};
// 进入房间状态
const roomErrorCode = {
  20013: "当前账号已存在一个派单厅",
  20014: "聊天室非法",
  20015: "房间数据更新，请刷新或重启软件",
}

//非开发环境
if (process.env.NODE_ENV == 'production') {
  config.ctxPath = '';
}
config.wealthDatas = wealthDatas;
config.glamourDatas = glamourDatas;
config.emojiList = emojiList;
config.errorCode = errorCode;
config.roomErrorCode = roomErrorCode;
export default config;
